// `hjid` defaults to the app's build-time site id. It is a parameter because a
// page can belong to more than one Hotjar site depending on the journey it
// serves, and only the caller knows which one: Hotjar binds a page load to the
// first site it is initialized with, so the choice has to be made before this
// call, not after.
export const initHotjar = (hjid = process.env.NX_PUBLIC_HOTJAR_ID) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // Skip when no site id is configured (e.g. local dev) to avoid injecting a
  // broken `hotjar-undefined.js` request.
  if (!hjid) return;

  // Skip re-injection when Hotjar is already initialized. In the You platform
  // each remote calls initHotjar() from its own bootstrap; when integrated
  // under the host only one bootstrap runs, but this guard keeps the call
  // idempotent regardless of how many bootstraps execute on the same page.
  if (window.hj) return;

  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
};

// Sends a Hotjar Identify call so sessions can be searched/filtered by the
// provided user id and User Attributes (e.g. flow, processId, companyName).
// `window.hj` is the synchronous stub queued by initHotjar, so calls made
// before the async script finishes loading are queued and replayed. No-op when
// Hotjar was never initialized (e.g. NX_PUBLIC_HOTJAR_ID absent in local dev).
export const identifyHotjar = (userId = null, attributes = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.hj !== 'function') return;

  window.hj('identify', userId ?? null, attributes ?? {});
};
